import * as React from "react";
import { cs } from "../../core/classSet";
import styles from "./Icons.module.css";

export const industryIconMap: Record<string, React.FC<React.SVGAttributes<SVGElement>>> = {
  manufacturing: ManufacturingAndIndustrialIcon,
  "property-management": PropertyManagementIcon,
  general: GeneralIcon,
  retail: RetailIcon,
  "food-beverage": FoodAndBeverageIcon,
  "fleet-management": FleetManagementIcon,
  hospitality: HospitalityIcon,
  "personal-use": PersonalUseIcon,
  healthcare: HealthcareIcon,
  "asset-management": AssetManagementIcon,
  facility: FacilityMaintenanceIcon,
  inventory: PartsInventoryManagementIcon,
  checklists: ChecklistsAndInspectionsIcon,
  preventive: ManufacturingAndIndustrialIcon,
  workOrder: WorkOrderManagementIcon,
  education: EducationAndSchoolsIcon,
};

type ArrowIconDirection = "up" | "right" | "down" | "left";

export function ArrowIcon({
  direction = "right",
  ...props
}: React.SVGAttributes<SVGElement> & { direction?: ArrowIconDirection }) {
  return (
    <svg
      className={cs(styles.animate, styles[direction || "right"])}
      width="14"
      height="14"
      {...props}
      viewBox="0 0 14 14"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.595 1.97a.75.75 0 011.06 0l4.5 4.5a.75.75 0 010 1.06l-4.5 4.5a.75.75 0 01-1.06-1.06L8.565 7l-3.97-3.97a.75.75 0 010-1.06z"
      />
    </svg>
  );
}

export function ArrowIcon2({ direction = "right", ...props }: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      className={cs(styles.animate, styles[direction || "right"])}
      width="7"
      height="10"
      {...props}
      viewBox="0 0 7 10"
      fill="none"
    >
      <path d="M1 9L5.01439 5L1 1" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function AvatarPlaceholderIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="64" height="64" {...props} viewBox="0 0 64 64">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.906.089c17.556 0 31.788 14.232 31.788 31.788S49.462 63.665 31.906 63.665.118 49.433.118 31.877 14.35.089 31.906.089z"
        fill="#1887FC"
      />
      <mask id="avatarPlaceholder" maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.906.089c17.556 0 31.788 14.232 31.788 31.788S49.462 63.665 31.906 63.665.118 49.433.118 31.877 14.35.089 31.906.089z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#avatarPlaceholder)">
        <path
          d="M31.14 63.155a.802.802 0 00.731-.409l6.383-11.054a.816.816 0 00.065-.682l-6.727-18.624a.727.727 0 00-.818-.472L11.282 35.4a.816.816 0 00-.558.398L4.342 46.852a.802.802 0 00.012.838c.16.245.449.37.741.317l18.883-3.378 6.517 18.042c.1.28.352.467.645.484zM46.822 37.3a.803.803 0 00.731-.408l6.383-11.055a.816.816 0 00.065-.682L47.275 6.532a.727.727 0 00-.82-.473l-19.49 3.487a.816.816 0 00-.558.397l-6.383 11.055a.802.802 0 00.012.837c.16.246.449.37.741.318l18.883-3.378 6.517 18.042c.1.28.352.467.645.483z"
          fill="#fff"
        />
        <path
          d="M10.293 35.773c.16.246.166.571.012.837L3.923 47.665a.816.816 0 01-.558.398l-19.492 3.486a.727.727 0 01-.819-.473l-6.726-18.623a.816.816 0 01.065-.682l6.383-11.055a.802.802 0 01.731-.408.726.726 0 01.645.483l6.517 18.042 18.883-3.377a.726.726 0 01.741.317zM25.975 9.918c.16.247.166.572.012.838L19.605 21.81a.817.817 0 01-.558.397L-.445 25.695a.727.727 0 01-.818-.473L-7.99 6.598a.816.816 0 01.066-.681l6.382-11.055a.802.802 0 01.731-.409.726.726 0 01.645.484l6.517 18.042 18.883-3.378a.726.726 0 01.741.317zM65.392 67.56c.161.247.166.572.013.838l-6.383 11.055a.817.817 0 01-.558.398l-19.492 3.486a.727.727 0 01-.818-.473l-6.727-18.623a.816.816 0 01.066-.682l6.382-11.055a.802.802 0 01.731-.408.726.726 0 01.646.483l6.516 18.042 18.883-3.377a.726.726 0 01.742.317zM81.075 41.707c.16.246.165.571.012.837l-6.383 11.055a.817.817 0 01-.558.397l-19.491 3.487a.727.727 0 01-.819-.473l-6.727-18.623a.816.816 0 01.066-.682l6.382-11.055a.802.802 0 01.731-.408.726.726 0 01.646.483l6.516 18.042 18.883-3.378a.726.726 0 01.742.318z"
          fill="#001E40"
        />
      </g>
    </svg>
  );
}

export function CalendarIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="16" height="16" {...props} viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M8.27 13.1a.73.73 0 100-1.46.73.73 0 000 1.45zm3.64 0a.73.73 0 100-1.46.73.73 0 000 1.45zm0-2.92a.73.73 0 100-1.45.73.73 0 000 1.45zm-3.64 0a.73.73 0 100-1.45.73.73 0 000 1.45zm5.1-8.73h-.73V.73a.73.73 0 00-1.46 0v.72H5.36V.73a.73.73 0 00-1.45 0v.72h-.73A2.18 2.18 0 001 3.64v10.18A2.18 2.18 0 003.18 16h10.18a2.18 2.18 0 002.19-2.18V3.64a2.18 2.18 0 00-2.19-2.19zm.72 12.37a.73.73 0 01-.73.73H3.18a.73.73 0 01-.73-.73V7.27H14.1v6.55zm0-8H2.45V3.64a.73.73 0 01.73-.73h.73v.73a.73.73 0 101.45 0V2.9h5.82v.73a.73.73 0 101.46 0V2.9h.72a.73.73 0 01.73.73v2.18zm-9.45 4.36a.73.73 0 100-1.45.73.73 0 000 1.45zm0 2.91a.73.73 0 100-1.45.73.73 0 000 1.45z"
      />
    </svg>
  );
}

export function CautionIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="16" height="16" {...props} viewBox="0 0 16 16">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.993 1.263a2.056 2.056 0 012.761.722l.002.003 5.97 9.941a2.043 2.043 0 01-.737 2.788c-.31.181-.66.279-1.018.283H2.029a2.057 2.057 0 01-1.76-1.033 2.043 2.043 0 01.006-2.038l.005-.008 5.964-9.933.002-.003c.183-.3.44-.55.747-.722zm.354 1.387v.001l-5.96 9.925a.761.761 0 00.653 1.14h11.92a.767.767 0 00.753-.765.76.76 0 00-.1-.376l-5.96-9.924a.764.764 0 00-1.306 0zM8 5.287c.356 0 .644.287.644.642v2.81a.643.643 0 01-1.288 0v-2.81c0-.355.289-.642.644-.642zm0 5.62a.643.643 0 100 1.283h.006a.643.643 0 100-1.284H8z"
      />
    </svg>
  );
}

export function CameraIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="18" height="18" {...props} viewBox="0 0 18 18">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.756 1.125a.771.771 0 00-.642.344l-1.267 1.9h-2.58A2.268 2.268 0 000 5.637v8.228a2.267 2.267 0 002.268 2.268h13.465A2.267 2.267 0 0018 13.865V5.637a2.268 2.268 0 00-2.268-2.268h-2.579l-1.267-1.9a.771.771 0 00-.642-.344H6.756zm.023 8.252a2.22 2.22 0 114.442 0 2.22 2.22 0 01-4.442 0zM9 5.613a3.764 3.764 0 100 7.528 3.764 3.764 0 000-7.528zm6.188 1.137a.562.562 0 100-1.125.562.562 0 000 1.125z"
      />
    </svg>
  );
}

export function CheckIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="16" height="16" {...props} viewBox="0 0 16 16">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.772 3.228a.778.778 0 010 1.1l-8.555 8.555a.778.778 0 01-1.1 0l-3.89-3.889a.778.778 0 111.1-1.1l3.34 3.34 8.005-8.006a.778.778 0 011.1 0z"
      />
    </svg>
  );
}

export function CloseIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="16" height="16" {...props} viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M9.175 8l3.58-3.573a.836.836 0 10-1.182-1.182L8 6.825l-3.572-3.58a.836.836 0 10-1.183 1.182L6.826 8l-3.58 3.572a.833.833 0 00.271 1.365.834.834 0 00.912-.182L8 9.174l3.572 3.58A.834.834 0 0013 12.163a.832.832 0 00-.246-.592L9.175 8z"
      />
    </svg>
  );
}

export function DownloadIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="16" height="16" {...props} viewBox="0 0 16 16">
      <path
        fill="currentcolor"
        d="M7.468 11.783a.75.75 0 00.247.157.75.75 0 00.57 0 .75.75 0 00.248-.157l3-3a.753.753 0 00-1.066-1.065L8.75 9.443V.75a.75.75 0 00-1.5 0v8.693L5.532 7.718a.75.75 0 00-1.229.244.75.75 0 00.165.82l3 3zM2.75 15h10.5a.75.75 0 100-1.5H2.75a.75.75 0 100 1.5z"
      />
    </svg>
  );
}

export function FacebookIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M1.668 10.002A8.338 8.338 0 008.7 18.234V12.41H6.585v-2.408h2.117V8.168a2.94 2.94 0 013.144-3.25c.625.01 1.249.066 1.866.167v2.05H12.66a1.205 1.205 0 00-1.357 1.302v1.565h2.31l-.37 2.409h-1.94v5.823a8.333 8.333 0 10-9.634-8.232z"
      />
    </svg>
  );
}

export function FileIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="12" height="12" {...props} viewBox="0 0 12 12">
      <path
        fill="currentColor"
        d="M4.313 4.95h.562c.15 0 .292-.055.398-.154a.508.508 0 00.165-.371c0-.14-.06-.273-.165-.371a.584.584 0 00-.398-.154h-.563a.584.584 0 00-.397.154.508.508 0 00-.165.371c0 .14.06.273.165.371a.584.584 0 00.397.154zm0 1.05a.584.584 0 00-.398.154.508.508 0 00-.165.371c0 .14.06.273.165.371a.584.584 0 00.397.154h3.375c.15 0 .293-.055.398-.154a.508.508 0 00.165-.371c0-.14-.06-.273-.165-.371A.584.584 0 007.687 6H4.313zM10.5 4.394a.65.65 0 00-.034-.142v-.047a.561.561 0 00-.107-.147L6.984.908a.606.606 0 00-.157-.1.193.193 0 00-.05 0A.52.52 0 006.59.75H3.187a1.75 1.75 0 00-1.193.461A1.524 1.524 0 001.5 2.325v7.35c0 .418.178.818.494 1.114a1.75 1.75 0 001.194.461h5.624a1.75 1.75 0 001.194-.461c.316-.296.494-.696.494-1.114v-5.25-.031zM7.125 2.54L8.582 3.9h-.895a.584.584 0 01-.397-.154.508.508 0 01-.165-.371V2.54zm2.25 7.135c0 .14-.06.273-.165.371a.583.583 0 01-.398.154H3.189a.583.583 0 01-.398-.154.508.508 0 01-.165-.371v-7.35c0-.14.06-.273.165-.371a.584.584 0 01.397-.154H6v1.575c0 .418.178.818.494 1.114a1.75 1.75 0 001.194.461h1.687v4.725zM7.687 8.1H4.313a.584.584 0 00-.397.154.508.508 0 00-.165.371c0 .14.06.273.165.371a.584.584 0 00.397.154h3.375c.15 0 .293-.055.398-.154a.508.508 0 00.165-.371c0-.14-.06-.273-.165-.371a.584.584 0 00-.398-.154z"
      />
    </svg>
  );
}

export function FleetManagementIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="32" height="32" {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.933 26.238V28a1.067 1.067 0 002.134 0v-1.6h13.866V28a1.067 1.067 0 102.134 0v-1.762l.177-.063a3.734 3.734 0 002.49-3.508m0 0v-16A3.733 3.733 0 0024 2.933H8a3.733 3.733 0 00-3.733 3.734v16a3.734 3.734 0 002.488 3.508l.178.063M6.4 18.4h19.2v4.267a1.6 1.6 0 01-1.6 1.6H8a1.6 1.6 0 01-1.6-1.6V18.4zm19.2-2.133H6.4v-9.6a1.6 1.6 0 011.6-1.6h16a1.6 1.6 0 011.6 1.6v9.6zm-8.267-9.334h-2.666a1.066 1.066 0 100 2.134h2.666a1.066 1.066 0 100-2.134z"
        fill="currentColor"
      />
      <path
        d="M22.4 21.267a1 1 0 11-2 0 1 1 0 012 0zM11.6 21.267a1 1 0 11-2 0 1 1 0 012 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export function FoodAndBeverageIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="32" height="32" {...props} viewBox="0 0 32 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.427 12.485l-.017-.017.017.017zm2.367 2.503a3.68 3.68 0 01-1.442.275 3.692 3.692 0 01-2.603-1.105l-.19-.192-6.576 6.618-.002.002-8.027 7.959a1.054 1.054 0 01-.75.308h-.002a1.05 1.05 0 01-.981-.655 1.072 1.072 0 01.232-1.166l7.343-7.376-3.68-3.69a14.39 14.39 0 01-3.45-5.622 14.464 14.464 0 01-.588-6.583.266.266 0 00.003-.038V3.7c0-.057.007-.114.027-.168.012-.03.024-.06.038-.09.033-.062.071-.122.115-.177l.011-.014a.105.105 0 01.029-.031l.056-.042a.449.449 0 01.06-.037l.146-.074a.23.23 0 00.03-.019.342.342 0 01.264-.072.266.266 0 00.042.003h.174c.066 0 .131.02.187.057.02.014.042.025.065.034l.222.087c.056.027.108.061.155.102.012.01.024.02.038.028l.031.02a.681.681 0 01.132.103l11.044 11.154 2.097-2.094-.188-.189a3.74 3.74 0 01-1.083-2.634c0-.988.39-1.935 1.084-2.634l3.742-3.766a1.062 1.062 0 01.75-.313 1.054 1.054 0 01.75.313 1.07 1.07 0 01.312.757 1.077 1.077 0 01-.312.757l-3.743 3.767a1.602 1.602 0 000 2.252l.189.192 4.858-4.903a1.062 1.062 0 01.75-.313 1.054 1.054 0 01.75.313 1.072 1.072 0 01.23 1.167c-.053.13-.131.247-.23.347l-4.868 4.885.185.188a1.59 1.59 0 001.13.474 1.581 1.581 0 001.127-.473h.001l3.78-3.752.003-.002a1.057 1.057 0 01.749-.314 1.049 1.049 0 01.75.314 1.069 1.069 0 010 1.502l-3.743 3.767c-.35.352-.765.63-1.223.817zm-15.23-.362l3.669 3.707 2.25-2.313-9.46-9.507.079.752a12.362 12.362 0 003.461 7.36zM19.542 18.581c.283.001.553.115.752.317l8.308 8.347a1.066 1.066 0 01.231 1.166 1.066 1.066 0 01-.575.576 1.05 1.05 0 01-.405.079h-.009c-.27.007-.533-.09-.734-.272l-8.328-8.38a1.079 1.079 0 01.006-1.521c.2-.2.472-.313.754-.312z"
      />
    </svg>
  );
}

export function GeneralIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="32" height="32" {...props} viewBox="0 0 32 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.716 5.467l.095.266h1.856a3.6 3.6 0 013.6 3.6v16a3.6 3.6 0 01-3.6 3.6H9.333a3.6 3.6 0 01-3.6-3.6v-16a3.6 3.6 0 013.6-3.6h1.857l.094-.266a3.6 3.6 0 013.383-2.4h2.666a3.6 3.6 0 013.383 2.4zM12.933 8.4h6.134V6.667a1.734 1.734 0 00-1.734-1.734h-2.666a1.733 1.733 0 00-1.734 1.734V8.4zm-1.866.933V7.6H9.333A1.733 1.733 0 007.6 9.333v16a1.733 1.733 0 001.733 1.734h13.334a1.733 1.733 0 001.733-1.734v-16A1.734 1.734 0 0022.667 7.6h-1.734v1.733a.933.933 0 01-.933.934h-8a.933.933 0 01-.933-.934zm.273 10.007a.933.933 0 01.66-.273h5.333a.934.934 0 010 1.866H12a.933.933 0 01-.66-1.593zm.66-5.607h8a.933.933 0 110 1.867h-8a.933.933 0 010-1.867z"
      />
    </svg>
  );
}

export function HealthcareIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="32" height="32" {...props} viewBox="0 0 32 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.067 24v-1.733h-1.733a.933.933 0 110-1.867h1.733v-1.733a.933.933 0 111.867 0V20.4h1.733a.934.934 0 010 1.867h-1.733V24a.933.933 0 01-1.867 0zm7.2-17.333V8.4h3.067a3.6 3.6 0 013.6 3.6v13.333a3.6 3.6 0 01-3.6 3.6H6.667a3.6 3.6 0 01-3.6-3.6V12a3.6 3.6 0 013.6-3.6h3.067V6.667a3.6 3.6 0 013.6-3.6h5.333a3.6 3.6 0 013.6 3.6zM11.6 8.4h8.8V6.667a1.733 1.733 0 00-1.733-1.734h-5.333A1.733 1.733 0 0011.6 6.667V8.4zm15.467 7.2H4.934v9.733a1.733 1.733 0 001.733 1.734h18.667a1.733 1.733 0 001.733-1.734V15.6zM4.934 13.733h22.133V12a1.733 1.733 0 00-1.733-1.733H6.667A1.733 1.733 0 004.934 12v1.733z"
      />
    </svg>
  );
}

export function HospitalityIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="32" height="32" {...props} viewBox="0 0 32 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.879 25.673h4.847a.946.946 0 00.784-.426l.002-.002 2.152-3.209h8.672l2.153 3.211a.944.944 0 00.784.426h4.848a.945.945 0 00.945-.946V8.97a3.37 3.37 0 00-3.37-3.37H6.304a3.37 3.37 0 00-3.37 3.37v15.757a.946.946 0 00.946.946zm19.907-1.891h3.39v-6.594H4.823v6.594h3.39l2.153-3.21v-.001a.945.945 0 01.785-.426h9.691a.945.945 0 01.78.473l.005.009 2.158 3.155zM9.672 13.818v1.479h5.382v-1.479a1.479 1.479 0 00-1.479-1.479h-2.424a1.479 1.479 0 00-1.479 1.479zm7.273 0v1.479h5.382v-1.479a1.479 1.479 0 00-1.479-1.479h-2.424a1.478 1.478 0 00-1.479 1.479zm7.273 1.479h2.957V8.97a1.479 1.479 0 00-1.478-1.48H6.303a1.479 1.479 0 00-1.479 1.48v6.327h2.958v-1.479a3.37 3.37 0 013.37-3.37h2.423a3.37 3.37 0 012.245.877l.18.163.18-.163a3.37 3.37 0 012.245-.877h2.423a3.37 3.37 0 013.37 3.37v1.479z"
      />
    </svg>
  );
}

export function InstagramIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M10.002 17.534c-2.05 0-2.292-.01-3.092-.046a5.485 5.485 0 01-1.82-.375 3.85 3.85 0 01-2.192-2.192 5.493 5.493 0 01-.35-1.823c-.046-.798-.046-1.06-.046-3.094 0-2.056.01-2.296.046-3.092.013-.622.13-1.237.35-1.82A3.842 3.842 0 015.092 2.9a5.444 5.444 0 011.82-.35c.796-.045 1.057-.045 3.09-.045 2.066 0 2.304.011 3.091.045.624.012 1.241.13 1.825.35a3.846 3.846 0 012.195 2.193c.222.591.34 1.217.35 1.848.047.798.047 1.06.047 3.093s-.012 2.3-.047 3.089a5.5 5.5 0 01-.35 1.824 3.854 3.854 0 01-2.195 2.193c-.583.219-1.199.337-1.821.35-.796.045-1.057.045-3.095.045zm-.029-13.71c-2.038 0-2.25.01-3.045.045a4.157 4.157 0 00-1.391.26 2.49 2.49 0 00-1.433 1.426 4.18 4.18 0 00-.259 1.406c-.044.807-.044 1.019-.044 3.043 0 2 .007 2.243.044 3.045.007.475.095.946.26 1.392a2.493 2.493 0 001.432 1.426 4.1 4.1 0 001.39.259c.807.046 1.02.046 3.046.046 2.044 0 2.256-.01 3.045-.046a4.137 4.137 0 001.392-.26 2.5 2.5 0 001.425-1.423c.166-.451.254-.927.26-1.407h.008c.036-.797.036-1.01.036-3.045 0-2.036-.009-2.25-.045-3.046a4.213 4.213 0 00-.259-1.39 2.5 2.5 0 00-1.425-1.427 4.119 4.119 0 00-1.392-.259c-.806-.046-1.016-.046-3.045-.046zm.029 10.03a3.853 3.853 0 11-.005-7.706 3.853 3.853 0 01.005 7.705zm0-6.356a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm4-.594a.898.898 0 11.006-1.797.898.898 0 01-.006 1.797z"
      />
    </svg>
  );
}

export function LinkIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="12" height="12" {...props} viewBox="0 0 12 12">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.368.75a2.906 2.906 0 00-2.046.817l-.82.817a.538.538 0 10.76.763l.812-.808a1.83 1.83 0 013.1 1.305c.003.48-.18.941-.512 1.286L8.244 6.35a1.83 1.83 0 01-2.76-.198.538.538 0 10-.863.645 2.908 2.908 0 004.385.314l1.422-1.423.006-.007A2.911 2.911 0 008.368.751zm-3.11 3.294a2.905 2.905 0 00-2.264.845L1.573 6.312l-.007.007a2.911 2.911 0 002.066 4.93 2.907 2.907 0 002.046-.816l.817-.818a.538.538 0 00-.762-.76l-.807.807a1.83 1.83 0 01-3.099-1.306c-.004-.48.18-.941.511-1.287L3.756 5.65a1.83 1.83 0 012.76.198.538.538 0 00.863-.645 2.908 2.908 0 00-2.12-1.16z"
      />
    </svg>
  );
}

export function LinkedInIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M10.833 17.5H7.5v-10h3.333v1.667a3.849 3.849 0 012.938-1.47 3.75 3.75 0 013.729 3.761V17.5h-3.333v-5.625a1.888 1.888 0 00-1.873-1.62 1.512 1.512 0 00-1.46 1.62V17.5zm-5 0H2.5v-10h3.333v10zM4.167 5.833a1.667 1.667 0 110-3.333 1.667 1.667 0 010 3.333z"
      />
    </svg>
  );
}

export function ManufacturingAndIndustrialIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="32" height="32" {...props} viewBox="0 0 32 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.412 13.402l-.263-.375v-.218a9.705 9.705 0 00-6.766-9.283h-.074l-.057-.018a10.174 10.174 0 00-3.16-.44 10.034 10.034 0 00-9.478 9.96l-.002.282-.265.094a3.413 3.413 0 000 6.439l.239.084.026.252a9.767 9.767 0 009.767 8.754h.285a9.933 9.933 0 009.374-8.747l.03-.254.242-.08a3.412 3.412 0 00.102-6.45zm-15.115 11.97a8.025 8.025 0 005.325 1.819h.009a8.14 8.14 0 007.592-6.684l.085-.47H7.398l.078.466a8.026 8.026 0 002.821 4.868zm-2.94-12.579l-.019.418h1.689a.871.871 0 010 1.741H6.485a1.67 1.67 0 100 3.342h17.793a1.671 1.671 0 000-3.342h-2.542a.871.871 0 010-1.742h1.67l.001-.4a8.026 8.026 0 00-2.434-5.764l-.008-.007a8.85 8.85 0 00-1.57-1.158l-.6-.348v4.736a.87.87 0 01-1.743 0V4.96l-.334-.055a8.839 8.839 0 00-1.33-.12h-.256c-.365.02-.728.06-1.087.12l-.334.055v5.309a.87.87 0 01-1.742 0V5.543l-.612.383a8.534 8.534 0 00-4 6.867z"
      />
    </svg>
  );
}

export function MenuIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24">
      <path fill="#fff" d="M0 0h24v24H0z" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.333 2C.597 2 0 2.707 0 3.579s.597 1.579 1.333 1.579h21.334c.736 0 1.333-.707 1.333-1.58C24 2.708 23.403 2 22.667 2H1.333zM0 12c0-.872.597-1.579 1.333-1.579h21.334c.736 0 1.333.707 1.333 1.579s-.597 1.579-1.333 1.579H1.333C.597 13.579 0 12.872 0 12zm0 8.421c0-.872.597-1.579 1.333-1.579h21.334c.736 0 1.333.707 1.333 1.579S23.403 22 22.667 22H1.333C.597 22 0 21.293 0 20.421z"
      />
    </svg>
  );
}

export function MinusIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="12" height="12" {...props} viewBox="0 0 12 12">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.75 5.906c0-.362.294-.656.656-.656h9.188a.656.656 0 010 1.313H1.406a.656.656 0 01-.656-.657z"
      />
    </svg>
  );
}

export function MXIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14">
      <path
        fill="#1887FC"
        d="M13.973 1.037a.275.275 0 00-.248-.162H9.318a.272.272 0 00-.215.107L4.697 6.697a.294.294 0 000 .356l4.406 5.715a.272.272 0 00.215.107h4.407a.275.275 0 00.248-.162.294.294 0 00-.033-.302L9.67 6.875l4.27-5.536a.294.294 0 00.033-.302z"
      />
      <path
        fill="#001E40"
        d="M4.876.982a.27.27 0 00-.214-.107H.274a.274.274 0 00-.247.162.295.295 0 00.033.302l4.25 5.536-4.25 5.536a.295.295 0 00-.033.302c.046.1.142.162.247.162h4.388a.27.27 0 00.214-.107l4.486-5.893L4.876.982z"
      />
    </svg>
  );
}

export function PersonalUseIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="32" height="32" {...props} viewBox="0 0 32 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.333 16.385l.218-.194a4.706 4.706 0 001.262-3.153 4.774 4.774 0 00-9.547 0 4.707 4.707 0 001.262 3.154l.244.26-.32.16a7.654 7.654 0 00-4.187 5.938 1.075 1.075 0 002.136.234v-.003a5.6 5.6 0 0111.117 0v.004a1.067 1.067 0 001.13.949l.018-.001h.131a1.066 1.066 0 00.924-1.17 7.653 7.653 0 00-1.301-3.49c-.715-1.039-1.675-1.935-2.796-2.513l-.29-.175zm-4.8-1.15a2.64 2.64 0 102.933-4.39 2.64 2.64 0 00-2.933 4.39zM6.666 2.933h18.667a3.734 3.734 0 013.733 3.734v18.666a3.733 3.733 0 01-3.733 3.734H6.666a3.734 3.734 0 01-3.733-3.734V6.667a3.733 3.733 0 013.733-3.734zm19.798 23.532c.3-.3.47-.707.47-1.132V6.667a1.6 1.6 0 00-1.6-1.6H6.665a1.6 1.6 0 00-1.6 1.6v18.666a1.6 1.6 0 001.6 1.6h18.667a1.6 1.6 0 001.132-.468z"
      />
    </svg>
  );
}

export function PropertyManagementIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="32" height="32" {...props} viewBox="0 0 32 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.4 4v22.933H28a1.067 1.067 0 010 2.134H4a1.066 1.066 0 010-2.134h1.6V4a1.067 1.067 0 011.066-1.067h18.667A1.067 1.067 0 0126.4 4zm-12 22.933h3.2v-5.866h-3.2v5.866zm5.333 0h4.533V5.067H7.733v21.866h4.533V20a1.067 1.067 0 011.067-1.067h5.333A1.067 1.067 0 0119.733 20v6.933zM20 10.4h-1.334a1.067 1.067 0 010-2.133H20a1.066 1.066 0 110 2.133zm0 5.333h-1.334a1.067 1.067 0 010-2.133H20a1.067 1.067 0 010 2.133zM13.333 10.4H12a1.067 1.067 0 010-2.133h1.333a1.067 1.067 0 010 2.133zm0 5.333H12a1.067 1.067 0 010-2.133h1.333a1.067 1.067 0 010 2.133z"
      />
    </svg>
  );
}

export function PlusIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="12" height="12" {...props} viewBox="0 0 12 12">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.656 1.406a.656.656 0 10-1.312 0v3.938H1.406a.656.656 0 100 1.312h3.938v3.938a.656.656 0 001.312 0V6.656h3.938a.656.656 0 000-1.312H6.656V1.406z"
      />
    </svg>
  );
}

export function RetailIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="32" height="32" {...props} viewBox="0 0 32 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.929 10.49l-.004-.091a.587.587 0 00-.047-.262l-2.592-6.48a.933.933 0 00-.933-.588H6.665a.934.934 0 00-.868.589l-2.586 6.469c-.037.09-.115.175-.107.271v.181c0 .036-.011.07-.025.104a.154.154 0 00-.01.064 4.934 4.934 0 002.464 4.108l.2.116V28a.933.933 0 00.932.933h18.66a.933.933 0 00.933-.933V15.024l.2-.115a4.932 4.932 0 002.466-4.243l.005-.06a.375.375 0 000-.115zM14.263 20.935v6.133h3.465v-6.133h-3.465zm5.331 6.133h4.799V15.604l-.398-.002a4.93 4.93 0 01-3.699-1.702l-.3-.346-.302.343a4.93 4.93 0 01-7.397 0l-.303-.343-.3.346A4.933 4.933 0 017.997 15.6l-.398.003v11.463h4.799V20a.934.934 0 01.933-.933h5.331a.933.933 0 01.933.933v7.066zm-8.257-17.058a.934.934 0 00-.273.653 3.069 3.069 0 01-6.131.222l-.003-.086 2.372-5.862H24.69l2.375 5.87-.007.093a3.067 3.067 0 01-3.065 2.836 3.066 3.066 0 01-3.065-3.066.934.934 0 00-1.866 0 3.067 3.067 0 11-6.131 0 .934.934 0 00-1.593-.66z"
      />
    </svg>
  );
}

export function TwitterIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M16.663 5.573a3.583 3.583 0 001.572-1.978c-.702.416-1.47.71-2.27.867a3.583 3.583 0 00-6.097 3.263 10.153 10.153 0 01-7.37-3.737 3.583 3.583 0 001.106 4.775 3.563 3.563 0 01-1.619-.448v.045c0 1.703 1.2 3.17 2.87 3.507a3.584 3.584 0 01-1.616.061 3.583 3.583 0 003.341 2.484 7.175 7.175 0 01-4.442 1.53c-.285 0-.57-.016-.854-.049A10.122 10.122 0 006.767 17.5 10.106 10.106 0 0016.942 7.324c0-.155-.004-.31-.011-.462a7.265 7.265 0 001.785-1.852c-.653.29-1.345.479-2.053.563z"
      />
    </svg>
  );
}

export function SearchIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.104 11.365l.158-.152a.744.744 0 010 1.034l-.002.002a.742.742 0 01-1.056 0l-1.795-1.796a4.94 4.94 0 01-7.876-4.112 4.946 4.946 0 014.805-4.808 4.94 4.94 0 015.06 4.537 4.947 4.947 0 01-.95 3.343l1.81 1.797-.154.155zm-5.62-1.421a3.453 3.453 0 01-3.388-4.132A3.458 3.458 0 015.81 3.096a3.453 3.453 0 014.129 3.39 3.458 3.458 0 01-3.455 3.458z"
      />
    </svg>
  );
}

export function StarsIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="16" height="16" {...props} viewBox="0 0 16 16">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 6a.25.25 0 01-.25-.25 2.002 2.002 0 00-2-2 .25.25 0 010-.5 2.002 2.002 0 002-2 .25.25 0 01.5 0 2.002 2.002 0 002 2 .25.25 0 010 .5 2.002 2.002 0 00-2 2A.25.25 0 014.5 6zm5.5 6a.267.267 0 01-.267-.267 3.47 3.47 0 00-3.466-3.466.267.267 0 010-.534 3.47 3.47 0 003.466-3.466.267.267 0 01.534 0 3.47 3.47 0 003.466 3.466.267.267 0 110 .534 3.47 3.47 0 00-3.466 3.466A.267.267 0 0110 12zm-4.141 2.941A.2.2 0 006.2 14.8a1.602 1.602 0 011.6-1.6.2.2 0 000-.4 1.602 1.602 0 01-1.6-1.6.2.2 0 00-.4 0 1.602 1.602 0 01-1.6 1.6.2.2 0 000 .4 1.602 1.602 0 011.6 1.6.2.2 0 00.059.141z"
      />
    </svg>
  );
}

export function YoutubeIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M10.005 15.843h-.017c-.051 0-5.22-.01-6.525-.364a2.083 2.083 0 01-1.47-1.47A22.076 22.076 0 011.655 10c-.006-1.346.11-2.69.348-4.014A2.137 2.137 0 013.474 4.5c1.269-.333 6.295-.333 6.509-.333H10c.053 0 5.235.01 6.526.364A2.088 2.088 0 0117.994 6c.242 1.327.356 2.675.34 4.025a22.133 22.133 0 01-.349 4.01 2.092 2.092 0 01-1.472 1.468c-1.267.336-6.295.34-6.508.34zM8.338 7.504l-.004 5 4.344-2.5-4.34-2.5z"
      />
    </svg>
  );
}

export function ChecklistsAndInspectionsIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg height="24" width="24" {...props} viewBox="0 0 24 24">
      <g fill="currentColor">
        <path
          data-color="color-2"
          d="M4.549,19.107.171,14,2,12l3.834,3.006L17,3l2,1L7.664,19.011a2,2,0,0,1-2.8.391A2.04,2.04,0,0,1,4.549,19.107Z"
        />
        <path d="M23,9H20a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Z" fill="currentColor" />
        <path d="M23,14H16a1,1,0,0,1,0-2h7a1,1,0,0,1,0,2Z" fill="currentColor" />
        <path d="M23,19H13a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export function AssetManagementIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg height="24" width="24" {...props} viewBox="0 0 24 24">
      <g strokeLinecap="square" strokeWidth="2" fill="none" stroke="currentColor">
        <path d="M19 1v4M23 11V8l-4-3-4 3v3M1 23h22M15 23v-8h8v8M1 23V13h10v10" />
      </g>
    </svg>
  );
}

export function FacilityMaintenanceIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg height="24" width="24" {...props} viewBox="0 0 24 24">
      <g
        strokeLinecap="square"
        strokeWidth="2"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit="10"
      >
        <path d="M5 23H1V13h4M9 16h2M9 19h2M9 13h2M13 6V2l10 3v18H5V9h10v14M19 19V9" />
      </g>
    </svg>
  );
}

export function PartsInventoryManagementIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24">
      <g fill="none">
        <path d="M18 3l-3 3V3H9C6.24 3 4 5.24 4 8h5v3h6V8l3 3h2V3h-2z" fill="currentColor" />
        <path d="M9 13v7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-7H9z" fill="currentColor" />
      </g>
    </svg>
  );
}
export function WorkOrderManagementIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg height="24" width="24" {...props} viewBox="0 0 24 24">
      <g strokeLinecap="square" strokeWidth="2" fill="none" stroke="currentColor">
        <path fill="currentColor" d="M15 1v6h6l-6-6z" stroke="none" />
        <path d="M15 1v6h6" />
        <path d="M15 1H3v22h18V7l-6-6zM7 7h4m-4 5h10M7 17h10" />
      </g>
    </svg>
  );
}

export function EducationAndSchoolsIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.0546 11.6737L2.58066 10.3026C2.46519 10.237 2.36915 10.142 2.30228 10.0272C2.23526 9.91218 2.19995 9.78145 2.19995 9.64833C2.19995 9.51521 2.23526 9.38448 2.30228 9.26946C2.36916 9.15468 2.46594 9.05926 2.58144 8.99364L11.1073 4.25704H11.1988L11.2346 4.24271C11.2792 4.22485 11.3252 4.21053 11.3721 4.19989H11.6808C11.7237 4.21023 11.7657 4.22406 11.8063 4.24125L11.8437 4.25704H11.9371L20.4653 8.99488L21.4169 9.5183C21.5328 9.58362 21.6293 9.67851 21.6966 9.79329C21.7641 9.90833 21.7997 10.0392 21.7999 10.1726V13.4489C21.7999 13.6485 21.7207 13.8399 21.5795 13.981C21.4384 14.1221 21.247 14.2014 21.0474 14.2014C20.8479 14.2014 20.6564 14.1221 20.5153 13.981C20.3742 13.8399 20.2949 13.6485 20.2949 13.4489V10.3835L17.9899 11.6743V17.809C17.9899 18.5138 17.7099 19.1898 17.2115 19.6882C16.7131 20.1866 16.0371 20.4666 15.3323 20.4666H7.71216C7.00733 20.4666 6.33137 20.1866 5.83298 19.6882C5.33459 19.1898 5.0546 18.5138 5.0546 17.809V11.6737ZM11.1415 15.0491L6.55964 12.5093V17.809C6.55964 18.1147 6.68107 18.4078 6.89721 18.624C7.11335 18.8401 7.40649 18.9615 7.71216 18.9615H15.3323C15.638 18.9615 15.9311 18.8401 16.1473 18.624C16.3634 18.4078 16.4848 18.1147 16.4848 17.809V12.5093L11.8919 15.055L11.8839 15.0599C11.8646 15.0718 11.8438 15.081 11.8221 15.0872H11.7478L11.7354 15.0888C11.6729 15.0967 11.6097 15.0967 11.5472 15.0888L11.5222 15.0857L11.4972 15.0888C11.4348 15.0967 11.3716 15.0967 11.3091 15.0888L11.2967 15.0872H11.2369L11.1415 15.0491ZM4.50029 9.6388L11.5222 13.5444L18.5442 9.6388L11.5222 5.73323L4.50029 9.6388Z"
        fill="currentColor"
      />
    </svg>
  );
}
